/* eslint-disable max-lines */
import React from 'react';
import Lottie from 'react-lottie';
import PropTypes from 'prop-types';

const HourGlass = ({ height, width }) => (
  <Lottie
    options={{
      loop: true,
      autoplay: true,
      animationData: {
        v: '5.5.10',
        fr: 30,
        ip: 0,
        op: 180,
        w: 1155,
        h: 700,
        nm: 'new sand gkass black',
        ddd: 0,
        assets: [],
        layers: [
          {
            ddd: 0,
            ind: 1,
            ty: 4,
            nm: 'Rectangle',
            parent: 3,
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [-1, 155.086, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 },
            },
            ao: 0,
            shapes: [
              {
                ty: 'gr',
                it: [
                  {
                    ty: 'rc',
                    d: 1,
                    s: { a: 0, k: [300, 16], ix: 2 },
                    p: { a: 0, k: [0, 0], ix: 3 },
                    r: { a: 0, k: 8, ix: 4 },
                    nm: 'Rectangle Path 1',
                    mn: 'ADBE Vector Shape - Rect',
                    hd: false,
                  },
                  {
                    ty: 'fl',
                    c: {
                      a: 0,
                      k: [0.9568627450980393, 0.4666666666666667, 0.13333333333333333, 1],
                      ix: 4,
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: 'Fill 1',
                    mn: 'ADBE Vector Graphic - Fill',
                    hd: false,
                  },
                  {
                    ty: 'tr',
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: 'Transform',
                  },
                ],
                nm: 'Rectangle',
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: 'ADBE Vector Group',
                hd: false,
              },
            ],
            ip: 0,
            op: 180,
            st: 0,
            bm: 0,
          },
          {
            ddd: 0,
            ind: 2,
            ty: 4,
            nm: 'Rectangle',
            parent: 3,
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [-1, -154.914, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 },
            },
            ao: 0,
            shapes: [
              {
                ty: 'gr',
                it: [
                  {
                    ty: 'rc',
                    d: 1,
                    s: { a: 0, k: [300, 16], ix: 2 },
                    p: { a: 0, k: [0, 0], ix: 3 },
                    r: { a: 0, k: 8, ix: 4 },
                    nm: 'Rectangle Path 1',
                    mn: 'ADBE Vector Shape - Rect',
                    hd: false,
                  },
                  {
                    ty: 'fl',
                    c: {
                      a: 0,
                      k: [0.9568627450980393, 0.4666666666666667, 0.13333333333333333, 1],
                      ix: 4,
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: 'Fill 1',
                    mn: 'ADBE Vector Graphic - Fill',
                    hd: false,
                  },
                  {
                    ty: 'tr',
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: 'Transform',
                  },
                ],
                nm: 'Rectangle',
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: 'ADBE Vector Group',
                hd: false,
              },
            ],
            ip: 0,
            op: 180,
            st: 0,
            bm: 0,
          },
          {
            ddd: 0,
            ind: 3,
            ty: 4,
            nm: 'Shape',
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: {
                a: 1,
                k: [
                  { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 80, s: [0] },
                  { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 90, s: [180] },
                  { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 170, s: [180] },
                  { t: 180, s: [360] },
                ],
                ix: 10,
              },
              p: { a: 0, k: [579, 350.914, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                    t: 80,
                    s: [100, 100, 100],
                  },
                  {
                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                    t: 85,
                    s: [125, 125, 100],
                  },
                  {
                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                    t: 90,
                    s: [100, 100, 100],
                  },
                  {
                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                    t: 170,
                    s: [100, 100, 100],
                  },
                  {
                    i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                    o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                    t: 175,
                    s: [125, 125, 100],
                  },
                  { t: 180, s: [100, 100, 100] },
                ],
                ix: 6,
              },
            },
            ao: 0,
            shapes: [
              {
                ty: 'gr',
                it: [
                  {
                    ind: 0,
                    ty: 'sh',
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                        ],
                        v: [
                          [-115, 149.086],
                          [-115, -149.164],
                          [-89, -149.164],
                        ],
                        c: false,
                      },
                      ix: 2,
                    },
                    nm: 'Path 1',
                    mn: 'ADBE Vector Shape - Group',
                    hd: false,
                  },
                  {
                    ind: 1,
                    ty: 'sh',
                    ix: 2,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                        ],
                        v: [
                          [-87, -149.164],
                          [89, 147.666],
                          [89, -149.164],
                          [-87, 148.836],
                        ],
                        c: true,
                      },
                      ix: 2,
                    },
                    nm: 'Path 2',
                    mn: 'ADBE Vector Shape - Group',
                    hd: false,
                  },
                  {
                    ind: 2,
                    ty: 'sh',
                    ix: 3,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                        ],
                        v: [
                          [-89, -149.164],
                          [115, -149.164],
                          [115, 149.086],
                        ],
                        c: false,
                      },
                      ix: 2,
                    },
                    nm: 'Path 3',
                    mn: 'ADBE Vector Shape - Group',
                    hd: false,
                  },
                  {
                    ty: 'mm',
                    mm: 1,
                    nm: 'Merge Paths 1',
                    mn: 'ADBE Vector Filter - Merge',
                    hd: false,
                  },
                  {
                    ty: 'st',
                    c: { a: 0, k: [0.16418504902, 0.16418504902, 0.16418504902, 1], ix: 3 },
                    o: { a: 0, k: 100, ix: 4 },
                    w: { a: 0, k: 6, ix: 5 },
                    lc: 1,
                    lj: 1,
                    ml: 4,
                    bm: 0,
                    nm: 'Stroke 1',
                    mn: 'ADBE Vector Graphic - Stroke',
                    hd: false,
                  },
                  {
                    ty: 'tr',
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: 'Transform',
                  },
                ],
                nm: 'Shape',
                np: 5,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: 'ADBE Vector Group',
                hd: false,
              },
            ],
            ip: 0,
            op: 180,
            st: 0,
            bm: 0,
          },
          {
            ddd: 0,
            ind: 4,
            ty: 4,
            nm: 'Path 6',
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [578.683, 389.625, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 },
            },
            ao: 0,
            shapes: [
              {
                ty: 'gr',
                it: [
                  {
                    ind: 0,
                    ty: 'sh',
                    ix: 1,
                    ks: {
                      a: 1,
                      k: [
                        {
                          i: { x: 0.667, y: 1 },
                          o: { x: 0.333, y: 0 },
                          t: 138,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [1, -3.99],
                                [-0.75, 1],
                                [1.2, 6.7],
                              ],
                              o: [
                                [0, 0],
                                [-1, 4],
                                [0.75, -1],
                                [-1.21, -6.71],
                              ],
                              v: [
                                [1.057, -37.376],
                                [-3.023, -30.271],
                                [1.477, -34.781],
                                [5.477, -30.376],
                              ],
                              c: true,
                            },
                          ],
                        },
                        {
                          i: { x: 0.667, y: 1 },
                          o: { x: 0.333, y: 0 },
                          t: 150,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [1, -3.99],
                                [-0.75, 1],
                                [1.2, 6.7],
                              ],
                              o: [
                                [0, 0],
                                [-1, 4],
                                [0.75, -1],
                                [-1.21, -6.71],
                              ],
                              v: [
                                [-1.193, -25.626],
                                [-2.523, 0.604],
                                [1.227, 25.594],
                                [2.227, -19.126],
                              ],
                              c: true,
                            },
                          ],
                        },
                        {
                          i: { x: 0.667, y: 1 },
                          o: { x: 0.333, y: 0 },
                          t: 165,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [1, -3.99],
                                [-0.75, 1],
                                [1.2, 6.7],
                              ],
                              o: [
                                [0, 0],
                                [-1, 4],
                                [0.75, -1],
                                [-1.21, -6.71],
                              ],
                              v: [
                                [-1.193, -25.626],
                                [-0.023, 20.104],
                                [-0.023, 36.844],
                                [1.727, 4.624],
                              ],
                              c: true,
                            },
                          ],
                        },
                        {
                          t: 170,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [1, -3.99],
                                [-0.75, 1],
                                [-1.285, 7.626],
                              ],
                              o: [
                                [0, 0],
                                [-1, 4],
                                [0.75, -1],
                                [1.133, -6.723],
                              ],
                              v: [
                                [-0.193, 22.999],
                                [-1.273, 35.229],
                                [-1.898, 60.594],
                                [-0.773, 37.124],
                              ],
                              c: true,
                            },
                          ],
                        },
                      ],
                      ix: 2,
                    },
                    nm: 'Path 1',
                    mn: 'ADBE Vector Shape - Group',
                    hd: false,
                  },
                  {
                    ty: 'fl',
                    c: { a: 0, k: [0.231372997165, 0.850979983807, 0.749019980431, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: 'Fill 1',
                    mn: 'ADBE Vector Graphic - Fill',
                    hd: false,
                  },
                  {
                    ty: 'tr',
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: 'Transform',
                  },
                ],
                nm: 'Path',
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: 'ADBE Vector Group',
                hd: false,
              },
            ],
            ip: 138,
            op: 171,
            st: 150,
            bm: 0,
          },
          {
            ddd: 0,
            ind: 5,
            ty: 4,
            nm: 'Path 5',
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [578.683, 389.625, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 },
            },
            ao: 0,
            shapes: [
              {
                ty: 'gr',
                it: [
                  {
                    ind: 0,
                    ty: 'sh',
                    ix: 1,
                    ks: {
                      a: 1,
                      k: [
                        {
                          i: { x: 0.667, y: 1 },
                          o: { x: 0.333, y: 0 },
                          t: 114,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [1, -3.99],
                                [-0.75, 1],
                                [1.2, 6.7],
                              ],
                              o: [
                                [0, 0],
                                [-1, 4],
                                [0.75, -1],
                                [-1.21, -6.71],
                              ],
                              v: [
                                [1.057, -37.376],
                                [-3.023, -30.271],
                                [1.477, -34.781],
                                [5.477, -30.376],
                              ],
                              c: true,
                            },
                          ],
                        },
                        {
                          i: { x: 0.667, y: 1 },
                          o: { x: 0.333, y: 0 },
                          t: 126,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [1, -3.99],
                                [-0.75, 1],
                                [1.2, 6.7],
                              ],
                              o: [
                                [0, 0],
                                [-1, 4],
                                [0.75, -1],
                                [-1.21, -6.71],
                              ],
                              v: [
                                [-1.193, -25.626],
                                [-2.523, 0.604],
                                [1.227, 25.594],
                                [2.227, -19.126],
                              ],
                              c: true,
                            },
                          ],
                        },
                        {
                          i: { x: 0.667, y: 1 },
                          o: { x: 0.333, y: 0 },
                          t: 141,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [1, -3.99],
                                [-0.75, 1],
                                [1.2, 6.7],
                              ],
                              o: [
                                [0, 0],
                                [-1, 4],
                                [0.75, -1],
                                [-1.21, -6.71],
                              ],
                              v: [
                                [-1.193, -25.626],
                                [-0.023, 20.104],
                                [-0.023, 36.844],
                                [1.727, 4.624],
                              ],
                              c: true,
                            },
                          ],
                        },
                        {
                          t: 146,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [1, -3.99],
                                [-0.75, 1],
                                [-1.285, 7.626],
                              ],
                              o: [
                                [0, 0],
                                [-1, 4],
                                [0.75, -1],
                                [1.133, -6.723],
                              ],
                              v: [
                                [-0.193, 22.999],
                                [-1.273, 35.229],
                                [-1.898, 60.594],
                                [-0.773, 37.124],
                              ],
                              c: true,
                            },
                          ],
                        },
                      ],
                      ix: 2,
                    },
                    nm: 'Path 1',
                    mn: 'ADBE Vector Shape - Group',
                    hd: false,
                  },
                  {
                    ty: 'fl',
                    c: { a: 0, k: [0.231372997165, 0.850979983807, 0.749019980431, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: 'Fill 1',
                    mn: 'ADBE Vector Graphic - Fill',
                    hd: false,
                  },
                  {
                    ty: 'tr',
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: 'Transform',
                  },
                ],
                nm: 'Path',
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: 'ADBE Vector Group',
                hd: false,
              },
            ],
            ip: 114,
            op: 147,
            st: 126,
            bm: 0,
          },
          {
            ddd: 0,
            ind: 6,
            ty: 4,
            nm: 'Path 4',
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [578.683, 389.625, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 },
            },
            ao: 0,
            shapes: [
              {
                ty: 'gr',
                it: [
                  {
                    ind: 0,
                    ty: 'sh',
                    ix: 1,
                    ks: {
                      a: 1,
                      k: [
                        {
                          i: { x: 0.667, y: 1 },
                          o: { x: 0.333, y: 0 },
                          t: 90,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [1, -3.99],
                                [-0.75, 1],
                                [1.2, 6.7],
                              ],
                              o: [
                                [0, 0],
                                [-1, 4],
                                [0.75, -1],
                                [-1.21, -6.71],
                              ],
                              v: [
                                [-1.193, -25.626],
                                [-2.523, 0.604],
                                [1.227, 25.594],
                                [2.227, -19.126],
                              ],
                              c: true,
                            },
                          ],
                        },
                        {
                          i: { x: 0.667, y: 1 },
                          o: { x: 0.333, y: 0 },
                          t: 105,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [1, -3.99],
                                [-0.75, 1],
                                [1.2, 6.7],
                              ],
                              o: [
                                [0, 0],
                                [-1, 4],
                                [0.75, -1],
                                [-1.21, -6.71],
                              ],
                              v: [
                                [-1.193, -25.626],
                                [-0.023, 20.104],
                                [-0.023, 36.844],
                                [1.727, 4.624],
                              ],
                              c: true,
                            },
                          ],
                        },
                        {
                          t: 110,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [1, -3.99],
                                [-0.75, 1],
                                [-1.285, 7.626],
                              ],
                              o: [
                                [0, 0],
                                [-1, 4],
                                [0.75, -1],
                                [1.133, -6.723],
                              ],
                              v: [
                                [-0.193, 22.999],
                                [-1.273, 35.229],
                                [-1.898, 60.594],
                                [-0.773, 37.124],
                              ],
                              c: true,
                            },
                          ],
                        },
                      ],
                      ix: 2,
                    },
                    nm: 'Path 1',
                    mn: 'ADBE Vector Shape - Group',
                    hd: false,
                  },
                  {
                    ty: 'fl',
                    c: { a: 0, k: [0.231372997165, 0.850979983807, 0.749019980431, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: 'Fill 1',
                    mn: 'ADBE Vector Graphic - Fill',
                    hd: false,
                  },
                  {
                    ty: 'tr',
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: 'Transform',
                  },
                ],
                nm: 'Path',
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: 'ADBE Vector Group',
                hd: false,
              },
            ],
            ip: 90,
            op: 111,
            st: 90,
            bm: 0,
          },
          {
            ddd: 0,
            ind: 7,
            ty: 4,
            nm: 'Path 3',
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [578.683, 389.625, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 },
            },
            ao: 0,
            shapes: [
              {
                ty: 'gr',
                it: [
                  {
                    ind: 0,
                    ty: 'sh',
                    ix: 1,
                    ks: {
                      a: 1,
                      k: [
                        {
                          i: { x: 0.667, y: 1 },
                          o: { x: 0.333, y: 0 },
                          t: 48,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [1, -3.99],
                                [-0.75, 1],
                                [1.2, 6.7],
                              ],
                              o: [
                                [0, 0],
                                [-1, 4],
                                [0.75, -1],
                                [-1.21, -6.71],
                              ],
                              v: [
                                [1.057, -37.376],
                                [-3.023, -30.271],
                                [1.477, -34.781],
                                [5.477, -30.376],
                              ],
                              c: true,
                            },
                          ],
                        },
                        {
                          i: { x: 0.667, y: 1 },
                          o: { x: 0.333, y: 0 },
                          t: 60,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [1, -3.99],
                                [-0.75, 1],
                                [1.2, 6.7],
                              ],
                              o: [
                                [0, 0],
                                [-1, 4],
                                [0.75, -1],
                                [-1.21, -6.71],
                              ],
                              v: [
                                [-1.193, -25.626],
                                [-2.523, 0.604],
                                [1.227, 25.594],
                                [2.227, -19.126],
                              ],
                              c: true,
                            },
                          ],
                        },
                        {
                          i: { x: 0.667, y: 1 },
                          o: { x: 0.333, y: 0 },
                          t: 75,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [1, -3.99],
                                [-0.75, 1],
                                [1.2, 6.7],
                              ],
                              o: [
                                [0, 0],
                                [-1, 4],
                                [0.75, -1],
                                [-1.21, -6.71],
                              ],
                              v: [
                                [-1.193, -25.626],
                                [-0.023, 20.104],
                                [-0.023, 36.844],
                                [1.727, 4.624],
                              ],
                              c: true,
                            },
                          ],
                        },
                        {
                          t: 80,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [1, -3.99],
                                [-0.75, 1],
                                [-1.285, 7.626],
                              ],
                              o: [
                                [0, 0],
                                [-1, 4],
                                [0.75, -1],
                                [1.133, -6.723],
                              ],
                              v: [
                                [-0.193, 22.999],
                                [-1.273, 35.229],
                                [-1.898, 60.594],
                                [-0.773, 37.124],
                              ],
                              c: true,
                            },
                          ],
                        },
                      ],
                      ix: 2,
                    },
                    nm: 'Path 1',
                    mn: 'ADBE Vector Shape - Group',
                    hd: false,
                  },
                  {
                    ty: 'fl',
                    c: { a: 0, k: [0.231372997165, 0.850979983807, 0.749019980431, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: 'Fill 1',
                    mn: 'ADBE Vector Graphic - Fill',
                    hd: false,
                  },
                  {
                    ty: 'tr',
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: 'Transform',
                  },
                ],
                nm: 'Path',
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: 'ADBE Vector Group',
                hd: false,
              },
            ],
            ip: 48,
            op: 81,
            st: 60,
            bm: 0,
          },
          {
            ddd: 0,
            ind: 8,
            ty: 4,
            nm: 'Path 2',
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [578.683, 389.625, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 },
            },
            ao: 0,
            shapes: [
              {
                ty: 'gr',
                it: [
                  {
                    ind: 0,
                    ty: 'sh',
                    ix: 1,
                    ks: {
                      a: 1,
                      k: [
                        {
                          i: { x: 0.667, y: 1 },
                          o: { x: 0.333, y: 0 },
                          t: 24,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [1, -3.99],
                                [-0.75, 1],
                                [1.2, 6.7],
                              ],
                              o: [
                                [0, 0],
                                [-1, 4],
                                [0.75, -1],
                                [-1.21, -6.71],
                              ],
                              v: [
                                [1.057, -37.376],
                                [-3.023, -30.271],
                                [1.477, -34.781],
                                [5.477, -30.376],
                              ],
                              c: true,
                            },
                          ],
                        },
                        {
                          i: { x: 0.667, y: 1 },
                          o: { x: 0.333, y: 0 },
                          t: 36,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [1, -3.99],
                                [-0.75, 1],
                                [1.2, 6.7],
                              ],
                              o: [
                                [0, 0],
                                [-1, 4],
                                [0.75, -1],
                                [-1.21, -6.71],
                              ],
                              v: [
                                [-1.193, -25.626],
                                [-2.523, 0.604],
                                [1.227, 25.594],
                                [2.227, -19.126],
                              ],
                              c: true,
                            },
                          ],
                        },
                        {
                          i: { x: 0.667, y: 1 },
                          o: { x: 0.333, y: 0 },
                          t: 51,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [1, -3.99],
                                [-0.75, 1],
                                [1.2, 6.7],
                              ],
                              o: [
                                [0, 0],
                                [-1, 4],
                                [0.75, -1],
                                [-1.21, -6.71],
                              ],
                              v: [
                                [-1.193, -25.626],
                                [-0.023, 20.104],
                                [-0.023, 36.844],
                                [1.727, 4.624],
                              ],
                              c: true,
                            },
                          ],
                        },
                        {
                          t: 56,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [1, -3.99],
                                [-0.75, 1],
                                [-1.285, 7.626],
                              ],
                              o: [
                                [0, 0],
                                [-1, 4],
                                [0.75, -1],
                                [1.133, -6.723],
                              ],
                              v: [
                                [-0.193, 22.999],
                                [-1.273, 35.229],
                                [-1.898, 60.594],
                                [-0.773, 37.124],
                              ],
                              c: true,
                            },
                          ],
                        },
                      ],
                      ix: 2,
                    },
                    nm: 'Path 1',
                    mn: 'ADBE Vector Shape - Group',
                    hd: false,
                  },
                  {
                    ty: 'fl',
                    c: { a: 0, k: [0.231372997165, 0.850979983807, 0.749019980431, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: 'Fill 1',
                    mn: 'ADBE Vector Graphic - Fill',
                    hd: false,
                  },
                  {
                    ty: 'tr',
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: 'Transform',
                  },
                ],
                nm: 'Path',
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: 'ADBE Vector Group',
                hd: false,
              },
            ],
            ip: 24,
            op: 57,
            st: 36,
            bm: 0,
          },
          {
            ddd: 0,
            ind: 9,
            ty: 4,
            nm: 'Path',
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [578.683, 389.625, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 },
            },
            ao: 0,
            shapes: [
              {
                ty: 'gr',
                it: [
                  {
                    ind: 0,
                    ty: 'sh',
                    ix: 1,
                    ks: {
                      a: 1,
                      k: [
                        {
                          i: { x: 0.667, y: 1 },
                          o: { x: 0.333, y: 0 },
                          t: 0,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [1, -3.99],
                                [-0.75, 1],
                                [1.2, 6.7],
                              ],
                              o: [
                                [0, 0],
                                [-1, 4],
                                [0.75, -1],
                                [-1.21, -6.71],
                              ],
                              v: [
                                [-1.193, -25.626],
                                [-2.523, 0.604],
                                [1.227, 25.594],
                                [2.227, -19.126],
                              ],
                              c: true,
                            },
                          ],
                        },
                        {
                          i: { x: 0.667, y: 1 },
                          o: { x: 0.333, y: 0 },
                          t: 15,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [1, -3.99],
                                [-0.75, 1],
                                [1.2, 6.7],
                              ],
                              o: [
                                [0, 0],
                                [-1, 4],
                                [0.75, -1],
                                [-1.21, -6.71],
                              ],
                              v: [
                                [-1.193, -25.626],
                                [-0.023, 20.104],
                                [-0.023, 36.844],
                                [1.727, 4.624],
                              ],
                              c: true,
                            },
                          ],
                        },
                        {
                          t: 20,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [1, -3.99],
                                [-0.75, 1],
                                [-1.285, 7.626],
                              ],
                              o: [
                                [0, 0],
                                [-1, 4],
                                [0.75, -1],
                                [1.133, -6.723],
                              ],
                              v: [
                                [-0.193, 22.999],
                                [-1.273, 35.229],
                                [-1.898, 60.594],
                                [-0.773, 37.124],
                              ],
                              c: true,
                            },
                          ],
                        },
                      ],
                      ix: 2,
                    },
                    nm: 'Path 1',
                    mn: 'ADBE Vector Shape - Group',
                    hd: false,
                  },
                  {
                    ty: 'fl',
                    c: { a: 0, k: [0.231372997165, 0.850979983807, 0.749019980431, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: 'Fill 1',
                    mn: 'ADBE Vector Graphic - Fill',
                    hd: false,
                  },
                  {
                    ty: 'tr',
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: 'Transform',
                  },
                ],
                nm: 'Path',
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: 'ADBE Vector Group',
                hd: false,
              },
            ],
            ip: 0,
            op: 21,
            st: 0,
            bm: 0,
          },
          {
            ddd: 0,
            ind: 10,
            ty: 4,
            nm: 'Path',
            parent: 3,
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [-1.5, -45.414, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 },
            },
            ao: 0,
            shapes: [
              {
                ty: 'gr',
                it: [
                  {
                    ind: 0,
                    ty: 'sh',
                    ix: 1,
                    ks: {
                      a: 1,
                      k: [
                        {
                          i: { x: 0.667, y: 1 },
                          o: { x: 0.333, y: 0 },
                          t: 0,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [-15.99, 2.66],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                              ],
                              o: [
                                [0, 0],
                                [15.99, -2.67],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                              ],
                              v: [
                                [-53.5, -45.5],
                                [-2.22, -23.74],
                                [53.5, -45.5],
                                [0.5, 45.5],
                                [-3.079, 39.684],
                                [-7.5, 32.5],
                              ],
                              c: true,
                            },
                          ],
                        },
                        {
                          i: { x: 0.667, y: 1 },
                          o: { x: 0.333, y: 0 },
                          t: 80,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [-15.99, 2.66],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                              ],
                              o: [
                                [0, 0],
                                [15.99, -2.67],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                              ],
                              v: [
                                [-11.75, 22.5],
                                [3.78, 25.26],
                                [20, 15.75],
                                [3.5, 46],
                                [-0.191, 40.073],
                                [-4.75, 32.75],
                              ],
                              c: true,
                            },
                          ],
                        },
                        {
                          i: { x: 0.667, y: 1 },
                          o: { x: 0.333, y: 0 },
                          t: 90,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [-15.99, 2.66],
                                [0, 0],
                                [0, 0],
                                [9.39, -0.997],
                                [0, 0],
                              ],
                              o: [
                                [0, 0],
                                [15.99, -2.67],
                                [0, 0],
                                [0, 0],
                                [-10.749, 1.141],
                                [0, 0],
                              ],
                              v: [
                                [-84.944, -104.972],
                                [4.308, -104.796],
                                [89.611, -104.306],
                                [85.667, -99.333],
                                [1.499, -88.063],
                                [-81.75, -100.611],
                              ],
                              c: true,
                            },
                          ],
                        },
                        {
                          i: { x: 0.667, y: 1 },
                          o: { x: 0.333, y: 0 },
                          t: 170,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [-15.99, 2.66],
                                [0, 0],
                                [0, 0],
                                [-2.015, -14.771],
                                [0, 0],
                              ],
                              o: [
                                [0, 0],
                                [15.99, -2.67],
                                [0, 0],
                                [0, 0],
                                [1.849, 13.553],
                                [0, 0],
                              ],
                              v: [
                                [-85.5, -105.5],
                                [4.03, -105.74],
                                [90.75, -106.25],
                                [86, -96.5],
                                [6.015, -62.401],
                                [-81.25, -96.5],
                              ],
                              c: true,
                            },
                          ],
                        },
                        {
                          t: 180,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [-15.99, 2.66],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                              ],
                              o: [
                                [0, 0],
                                [15.99, -2.67],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                              ],
                              v: [
                                [-53.5, -45.5],
                                [-2.22, -23.74],
                                [53.5, -45.5],
                                [0.5, 45.5],
                                [-3.079, 39.684],
                                [-7.5, 32.5],
                              ],
                              c: true,
                            },
                          ],
                        },
                      ],
                      ix: 2,
                    },
                    nm: 'Path 1',
                    mn: 'ADBE Vector Shape - Group',
                    hd: false,
                  },
                  {
                    ty: 'fl',
                    c: { a: 0, k: [0.231372997165, 0.850979983807, 0.749019980431, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: 'Fill 1',
                    mn: 'ADBE Vector Graphic - Fill',
                    hd: false,
                  },
                  {
                    ty: 'tr',
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: 'Transform',
                  },
                ],
                nm: 'Path',
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: 'ADBE Vector Group',
                hd: false,
              },
            ],
            ip: 0,
            op: 180,
            st: 0,
            bm: 0,
          },
          {
            ddd: 0,
            ind: 11,
            ty: 4,
            nm: 'Path',
            parent: 3,
            sr: 1,
            ks: {
              o: { a: 0, k: 100, ix: 11 },
              r: { a: 0, k: 0, ix: 10 },
              p: { a: 0, k: [-1.5, 128.796, 0], ix: 2 },
              a: { a: 0, k: [0, 0, 0], ix: 1 },
              s: { a: 0, k: [100, 100, 100], ix: 6 },
            },
            ao: 0,
            shapes: [
              {
                ty: 'gr',
                it: [
                  {
                    ind: 0,
                    ty: 'sh',
                    ix: 1,
                    ks: {
                      a: 1,
                      k: [
                        {
                          i: { x: 0.667, y: 1 },
                          o: { x: 0.333, y: 0 },
                          t: 0,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [-3.33, 10.99],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                              ],
                              o: [
                                [0, 0],
                                [3.33, -11],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                              ],
                              v: [
                                [-84.5, 14.286],
                                [-2.89, -18.054],
                                [34.897, -8.205],
                                [85.5, 14.286],
                                [88.5, 22.026],
                                [4.373, 22.026],
                                [-88.5, 22.026],
                              ],
                              c: true,
                            },
                          ],
                        },
                        {
                          i: { x: 0.667, y: 1 },
                          o: { x: 0.333, y: 0 },
                          t: 80,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [-7.36, 12.595],
                                [-5.045, -7.618],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                              ],
                              o: [
                                [0, 0],
                                [10.154, -17.376],
                                [9.576, 14.46],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                              ],
                              v: [
                                [-84.5, 14.286],
                                [-6.14, -43.304],
                                [37.424, -26.67],
                                [85.5, 14.286],
                                [88.5, 22.026],
                                [4.373, 22.026],
                                [-88.5, 22.026],
                              ],
                              c: true,
                            },
                          ],
                        },
                        {
                          i: { x: 0.667, y: 1 },
                          o: { x: 0.333, y: 0 },
                          t: 90,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [-7.36, 12.595],
                                [-5.045, -7.618],
                                [0, 0],
                                [0, 0],
                                [32.5, 2.093],
                                [0, 0],
                              ],
                              o: [
                                [0, 0],
                                [10.154, -17.376],
                                [9.576, 14.46],
                                [0, 0],
                                [0, 0],
                                [-25.699, -1.655],
                                [0, 0],
                              ],
                              v: [
                                [-43.5, -51.214],
                                [-12.64, -102.304],
                                [6.424, -121.67],
                                [38, -69.714],
                                [79, -0.974],
                                [-1, -31.474],
                                [-76, 6.526],
                              ],
                              c: true,
                            },
                          ],
                        },
                        {
                          i: { x: 0.667, y: 1 },
                          o: { x: 0.333, y: 0 },
                          t: 170,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [-7.36, 12.595],
                                [-5.045, -7.618],
                                [0, 0],
                                [0, 0],
                                [32.5, 2.093],
                                [0, 0],
                              ],
                              o: [
                                [0, 0],
                                [10.154, -17.376],
                                [9.576, 14.46],
                                [0, 0],
                                [0, 0],
                                [-25.699, -1.655],
                                [0, 0],
                              ],
                              v: [
                                [-26, -81.214],
                                [-12.64, -102.304],
                                [6.424, -121.67],
                                [38, -69.714],
                                [57, -34.474],
                                [7.5, -57.974],
                                [-54, -32.974],
                              ],
                              c: true,
                            },
                          ],
                        },
                        {
                          t: 180,
                          s: [
                            {
                              i: [
                                [0, 0],
                                [-3.33, 10.99],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                              ],
                              o: [
                                [0, 0],
                                [3.33, -11],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                              ],
                              v: [
                                [-84.5, 14.286],
                                [-2.89, -18.054],
                                [34.897, -8.205],
                                [85.5, 14.286],
                                [88.5, 22.026],
                                [4.373, 22.026],
                                [-88.5, 22.026],
                              ],
                              c: true,
                            },
                          ],
                        },
                      ],
                      ix: 2,
                    },
                    nm: 'Path 1',
                    mn: 'ADBE Vector Shape - Group',
                    hd: false,
                  },
                  {
                    ty: 'fl',
                    c: { a: 0, k: [0.231372997165, 0.850979983807, 0.749019980431, 1], ix: 4 },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: 'Fill 1',
                    mn: 'ADBE Vector Graphic - Fill',
                    hd: false,
                  },
                  {
                    ty: 'tr',
                    p: { a: 0, k: [0, 0], ix: 2 },
                    a: { a: 0, k: [0, 0], ix: 1 },
                    s: { a: 0, k: [100, 100], ix: 3 },
                    r: { a: 0, k: 0, ix: 6 },
                    o: { a: 0, k: 100, ix: 7 },
                    sk: { a: 0, k: 0, ix: 4 },
                    sa: { a: 0, k: 0, ix: 5 },
                    nm: 'Transform',
                  },
                ],
                nm: 'Path',
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: 'ADBE Vector Group',
                hd: false,
              },
            ],
            ip: 0,
            op: 180,
            st: 0,
            bm: 0,
          },
        ],
        markers: [],
      },
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    }}
    height={height}
    width={width}
  />
);

HourGlass.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
};

HourGlass.defaultProps = {
  height: 300,
  width: 400,
};

export default HourGlass;
